import {useState} from 'react';

const useForceUpdate = () => {
  const [last, setLast] = useState(false);
  return () => setLast(!last);
};

export default useForceUpdate;
